<template>
  <v-container fluid grid-list-md text-xs-left class="gridContainer px-0 py-0 mx-0 my-0">
    <v-layout row wrap>
      <v-flex d-flex xs12>
        <ticket-form
          :dealId="dealModel.dealId"
          :productCode="dealModel.productCode"
          :clientId="dealModel.clientId"
          :origin="'FUTURE'"
          v-model="ticketFormVisible"
        />

        <div style="width: 100%">
          <range-deals v-model="addRangeDealsDialog" @datesSelected="onRangeDatesSelected" />

          <page-toolbar class="toolbar-dark">
            <kendo-button icon="add" title="Add Trade" v-if="editable" @click="addRowClick">
            </kendo-button>
            <kendo-button
              icon="cancel"
              title="Cancel Changes"
              v-if="editable"
              @click="cancelGridChanges"
            >
            </kendo-button>
            <kendo-button
              icon="copy"
              title="Duplicate"
              v-if="editable"
              @click="openRangeDealsDialog"
            >
            </kendo-button>
            <kendo-button v-if="false" icon="eye" title="Show All" @click="showAllClick">
            </kendo-button>
            <kendo-button icon="excel" title="Export Ticket" @click="exportToExcel"> </kendo-button>
            <kendo-button icon="window" title="Future Ticket" @click="openTicketForm">
            </kendo-button>
          </page-toolbar>
          <kendo-grid
            ref="operationGrid"
            :data-source="this.dataSource"
            style="width:100%;font-size:82%"
            :height="hasOrders ? 'calc(100vh - 540px)' : 'calc(100vh - 390px)'"
            :editable="editableSettings"
            :navigatable="true"
            :filterable="false"
            :pageable="false"
            :sortable="false"
            :scrollable="true"
            :pageable-always-visible="true"
            :columns="gridColumns"
          ></kendo-grid>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import RangeDeals from './RangeDeals'
import params from '@/helpers/params'
import {
  checkboxColumn,
  jsonDropDownEditor,
  datePickerEditor,
  numericEditor,
  readOnlyEditor,
} from '@/helpers/kendo-editors'
import {isBuyingEditor} from './editors'
import TicketForm from '@/components/TicketForm'
import confirm from '@/helpers/confirmation-window'

export default {
  inject: ['EventBus'],
  mounted() {
    this.EventBus.$on('addOperationsFromOrder', this.onAddOperationsFromOrder)
  },
  props: {
    dealModel: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    hasOrders: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    addRangeDealsDialog: false,
    productDetail: {},
    ticketFormVisible: false,
  }),
  watch: {
    'dealModel.productId': {
      immediate: true,
      async handler(newValue) {
        this.productDetail = await this.getProductDetail(newValue)
        this.initializeOperationGrid()
      },
    },
    'dealModel.futureOperations': function() {
      this.sync()
    },
    'dealModel.referenceRate': function referenceRateChange(newValue) {
      let operations = this.dataSource.data()
      operations.forEach(oper => {
        this.recalculateGainLoss(newValue, oper)
      })
    },
    'dealModel.futureContractCommission': function() {
      let operations = this.dataSource.data()
      operations.forEach(operation => {
        operation.set(
          'commission',
          operation.numberContract * this.dealModel.futureContractCommission || 0,
        )
      })
    },
  },
  methods: {
    async getProductDetail(productId) {
      const {data: productDetail} = await axios.get('/api/list/Future/getFutureProductDetail', {
        params: {productId, clientId: this.clientId},
      })

      return productDetail
    },
    onRangeDatesSelected(dates) {
      dates.forEach(({endDate}) => {
        const row = this.dataSource._createNewModel()
        row.set('contractMonth', endDate)
        row.set('yearMonth', endDate)
        row.set('lastDeliveryDate', endDate)
        this.dataSource.add(row)
      })
    },
    validate() {
      // TODO: Custom validation if needed
      this.sync()
      return []
    },
    isEmpty() {
      return this.dataSource.data().length == 0
    },
    sync() {
      return this.dataSource.sync()
    },
    addRowClick() {
      let grid = this.$refs.operationGrid.kendoWidget()
      grid.addRow()
    },
    cancelGridChanges() {
      this.dataSource.cancelChanges()
    },
    showAllClick(e) {
      this.showAllColumns = !this.showAllColumns
      const buttonIcon = e.sender.element.children()
      buttonIcon.toggleClass('k-i-eye')
      buttonIcon.toggleClass('k-i-filter-clear')
    },
    exportToExcelGrid() {
      const qs = params.fromObject({
        dealId: this.dealModel.dealId,
        dealTypeId: 3,
        marketId: this.dealModel.marketId,
        clientId: this.clientId,
        t: this.tokenString,
      })
      location.href = `/api/list/deal/dealFormGridExport?${qs}`
    },
    exportToExcel() {
      const hasChanges = this.dataSource.hasChanges()
      if (hasChanges) {
        confirm.openConfirmationWindow(
          'Has changes!',
          'You want to save the changes to continue?',
          () => {
            this.$emit('save-operation')

            this.dataSource.read().then(() => {
              this.exportTicketToExcelFile()
            })
          },
        )
      } else {
        this.exportTicketToExcelFile()
      }
    },
    exportTicketToExcelFile() {
      const qs = params.fromObject({
        dealId: this.dealModel.dealId,
        clientId: this.dealModel.clientId,
        url: location.origin,
        t: this.tokenString,
      })
      setTimeout(function() {
        location.href = `/api/list/Future/exportContractTicket?${qs}`
      }, 182)
    },
    openTicketForm() {
      const hasChanges = this.dataSource.hasChanges()
      if (hasChanges) {
        confirm.openConfirmationWindow(
          'Has changes!',
          'You want to save the changes to continue?',
          () => {
            this.$emit('save-operation')

            this.dataSoruce.read().then(() => {
              this.ticketFormVisible = true
            })
          },
        )
      } else {
        this.ticketFormVisible = true
      }
    },
    getLastItemValue: function(key) {
      if (!this.dataSource) return
      let [lastItem] = this.dataSource.data().slice(-1)
      if (lastItem) {
        return lastItem[key]
      }
      return ''
    },
    openRangeDealsDialog: function() {
      this.addRangeDealsDialog = !this.addRangeDealsDialog
    },
    endOfMonth(date) {
      const newDate = new Date(date.getTime())
      newDate.setHours(0, 0, 0, 0)
      return new Date(date.getFullYear(), date.getMonth() + 1, 0)
    },
    onAddOperationsFromOrder({dates, order}) {
      const contractSize = this.getLastItemValue('contractSize') || this.productDetail.contractSize

      const {amount: quantity, orderRate, ccy2, legId, legCode} = order
      const numberContract = Math.floor(quantity / contractSize)
      const ccyAmount = quantity * orderRate

      dates.forEach(({endDate}) => {
        const row = this.dataSource._createNewModel()
        row.set('legId', legId)
        row.set('legCode', legCode)
        row.set('ccy', ccy2)
        row.set('contractMonth', endDate)
        row.set('lastDeliveryDate', endDate)
        row.set('yearMonth', endDate)
        row.set('numberContract', numberContract)
        row.set('quantity', numberContract * contractSize)
        row.set('price', orderRate)
        row.set('ccyAmount', ccyAmount)
        row.set('commission', numberContract * this.dealModel.futureContractCommission || 0)

        this.dataSource.add(row)
      })
    },
    initializeOperationGrid() {
      if (this.dealModel.dealId == 0) {
        this.dataSource.cancelChanges()
        const item = this.dataSource._createNewModel()
        this.dataSource.add(item)
      }
    },
    recalculateGainLoss(referenceRate, operation) {
      if (referenceRate == 0) {
        operation.set('gainLoss', 0)
        return
      }

      const gainLoss = operation.isBuying
        ? referenceRate * operation.quantity - operation.ccyAmount
        : operation.ccyAmount - referenceRate * operation.quantity

      if (!isFinite(gainLoss)) return

      operation.set('gainLoss', gainLoss)
    },
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    editableSettings: function() {
      return {
        mode: 'incell',
        update: this.editable,
        destroy: this.editable,
        confirmation: false,
        createAt: 'bottom',
      }
    },
    gridColumns: function() {
      const textRight = {
        attributes: {style: 'text-align: right;'},
      }

      const columns = [
        {
          field: 'dealCode',
          title: 'Trade Id',
          width: 82,
          locked: true,
          template: item => `<span>${item.dealCode}</span>`,
        },
        {
          field: 'isBuying',
          title: 'Buy / Sell',
          width: 80,
          editor: isBuyingEditor,
          template: function(dataItem) {
            return '<span>' + (dataItem.isBuying ? 'Buy' : 'Sell') + '</span>'
          },
        },
        {
          field: 'legCode',
          title: 'Leg',
          width: 90,
          editor: function(container, options) {
            return jsonDropDownEditor(
              'legId',
              'legCode',
              `/api/list/deal/getLegs?dealTypeId=3&legId=${options.model.legId}`,
              {
                autoWidth: true,
                dataBound: function() {
                  this.trigger('change')
                },
              },
              false,
            ).call(this, container, options)
          },
        },
        {
          field: 'numberContract',
          title: 'Number of Contract',
          width: 110,
          format: '{0:N0}',
          editor: numericEditor({
            decimals: 2,
            format: '{0:n0}',
            spinners: false,
            step: 0,
          }),
          ...textRight,
        },
        {
          field: 'contractSize',
          title: 'Contract Size',
          width: 100,
          format: '{0:N0}',
          ...textRight,
        },
        {
          field: 'quantity',
          title: 'Quantity',
          width: 110,
          format: '{0:N0}',
          ...textRight,
          editor: readOnlyEditor,
        },
        {
          field: 'unit',
          title: 'Unit',
          width: 80,
        },
        {
          field: 'underlying',
          title: 'Underlying',
          width: 114,
        },
        {
          field: 'price',
          title: 'Price',
          width: 110,
          format: '{0:N5}',
          editor: numericEditor({
            decimals: 5,
            format: '{0:n5}',
            spinners: false,
            step: 0,
          }),
          ...textRight,
        },
        {
          field: 'contractMonth',
          title: 'Contract Month',
          width: 100,
          format: '{0:yyyy-MM}',
          attributes: {style: 'text-align: right;'},
          editor: datePickerEditor({format: 'yyyy-MM', start: 'year', depth: 'year'}),
        },
        {
          field: 'lastDeliveryDate',
          title: 'Last Delivery Date',
          width: 100,
          format: '{0:yyyy-MM-dd}',
          editor: datePickerEditor({format: 'yyyy-MM-dd'}, true),
          ...textRight,
        },
        {
          field: 'yearMonth',
          title: 'Hedge Year/Month',
          width: 100,
          format: '{0:yyyy-MM}',
          attributes: {style: 'text-align: right;'},
          editor: datePickerEditor({format: 'yyyy-MM', start: 'year', depth: 'year'}, true),
        },
        {
          field: 'ccyAmount',
          title: 'Ccy Amount',
          width: 110,
          format: '{0:N0}',
          ...textRight,
          editor: readOnlyEditor,
        },
        {
          field: 'ccy',
          title: 'Ccy',
          width: 80,
          editor: readOnlyEditor,
        },
        {
          field: 'hedgeTypeCode',
          title: 'Hedge Type',
          width: 90,
          editor: jsonDropDownEditor(
            'hedgeTypeId',
            'hedgeTypeCode',
            `/api/list/deal/getHedgeTypes?clientId=${this.clientId}&dealId=${
              this.dealModel.dealId
            }&marketId=${this.dealModel.marketId}`,
            {
              dataBound: function() {
                this.trigger('change')
              },
            },
            true,
          ),
        },
        {
          field: 'commission',
          title: 'Commission',
          width: 114,
          format: '{0:N2}',
          editor: numericEditor({
            decimals: 5,
            format: '{0:n2}',
            spinners: false,
            step: 0,
          }),
          ...textRight,
        },
        {
          field: 'gainLoss',
          title: 'Gain/Loss',
          width: 114,
          format: '{0:N2}',
          ...textRight,
          editor: readOnlyEditor,
        },
        checkboxColumn('isExercised', {title: 'Exerc.', width: 80}, false, true),
        {
          field: 'otherBarrier2',
          title: 'Other barrier',
          width: 100,
          editor: numericEditor({
            decimals: 16,
            format: '{0:n6}',
            spinners: false,
            step: 0,
          }),
          attributes: {style: 'text-align: right;'},
          template: function(dataItem) {
            if (dataItem.otherBarrier2 == null) return ''
            return '<span>' + kendo.toString(Math.abs(dataItem.otherBarrier2), 'n6') + '</span>'
          },
        },
        {
          field: 'optionTypeName',
          title: 'Opt. Type',
          width: 110,
          editor: jsonDropDownEditor(
            'optionTypeId',
            'optionTypeName',
            '/api/list/deal/getOptionTypes',
            {},
            true,
          ),
        },
        {
          field: 'settlementMethodName',
          title: 'Settlement Method',
          width: 110,
          editor: jsonDropDownEditor(
            'settlementMethodId',
            'settlementMethodName',
            '/api/list/deal/getSettlementMethods',
            {
              dataBound: function() {
                this.trigger('change')
              },
            },
            true,
          ),
        },
        {
          field: 'reference',
          title: 'Ref.',
          width: 142,
        },
        {
          command: 'destroy',
          title: '&nbsp;',
          width: 64,
          hidden: !this.editable,
        },
        {},
      ]
      return columns
    },
    dataSource() {
      if (!this.dealModel.futureOperations) return null
      return new kendo.data.DataSource({
        transport: {
          read: e => {
            e.success(this.dealModel.futureOperations)
          },
          update: e => {
            const [item] = this.dealModel.futureOperations.filter(d => {
              return d.operationIdentifier == e.data.operationIdentifier
            })

            Object.assign(item, e.data)

            e.success()
          },
          create: e => {
            var item = e.data
            item.operationIdentifier = 'Oper' + Math.floor(Math.random() * 1e5)

            e.success(item)
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dealModel.futureOperations.push(item)
          },
          destroy: e => {
            const deletedOperId = e.data.operationIdentifier
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dealModel.futureOperations = this.dealModel.futureOperations.filter(d => {
              return d.operationIdentifier != deletedOperId
            })
            e.success(e.data)
          },
        },
        schema: {
          model: {
            id: 'operationIdentifier',
            fields: {
              operationIdentifier: {type: 'string'},
              operationId: {type: 'number'},
              dealCode: {type: 'string', editable: false},
              reference: {type: 'string'},
              legId: {
                type: 'number',
                defaultValue: () => {
                  return this.getLastItemValue('legId') || 6
                },
              },
              legCode: {
                type: 'string',
                defaultValue: () => {
                  return this.getLastItemValue('legCode') || 'FUT'
                },
              },
              contractMonth: {type: 'date'},
              yearMonth: {
                type: 'date',
                defaultValue: () => {
                  const today = new Date()
                  return kendo.parseDate(`${today.getFullYear()}-${today.getMonth() + 1}-01`)
                },
              },
              lastDeliveryDate: {
                type: 'date',
                defaultValue: () => {
                  const today = new Date()
                  return this.endOfMonth(today)
                },
              },
              isBuying: {
                type: 'boolean',
                defaultValue: () => {
                  return this.getLastItemValue('isBuying') || this.productDetail.isBuying
                },
              },
              buySell: {
                type: 'string',
                defaultValue: () => {
                  return (
                    this.getLastItemValue('buySell') || this.dealModel.defaultDealOptions.buySell
                  )
                },
              },
              numberContract: {
                type: 'number',
                defaultValue: () => {
                  return this.getLastItemValue('numberContract') || 0
                },
              },
              quantity: {
                type: 'number',
                defaultValue: () => {
                  return this.getLastItemValue('quantity') || 0
                },
              },
              underlying: {
                type: 'string',
                defaultValue: () => {
                  return this.getLastItemValue('underlying') || this.productDetail.underlying
                },
                editable: false,
              },
              price: {
                type: 'number',
                defaultValue: () => {
                  return this.getLastItemValue('price') || 0
                },
              },
              ccyAmount: {
                type: 'number',
                defaultValue: () => {
                  return this.getLastItemValue('ccyAmount') || 0
                },
              },
              contractSize: {
                type: 'number',
                editable: false,
                defaultValue: () => this.productDetail.contractSize,
              },
              ccy: {
                type: 'string',
                defaultValue: () => {
                  return this.getLastItemValue('ccy') || this.productDetail.ccy
                },
              },
              unit: {
                type: 'string',
                defaultValue: () => {
                  return this.getLastItemValue('unit') || this.productDetail.unit
                },
                editable: false,
              },
              hedgeTypeCode: {
                type: 'string',
                defaultValue: () => {
                  var hedgeTypeCode =
                    this.getLastItemValue('hedgeTypeCode') || this.dealModel.defaultHedgeTypeCode
                  return hedgeTypeCode
                },
              },
              hedgeTypeId: {
                type: 'number',
                defaultValue: () => {
                  var hedgeTypeId =
                    this.getLastItemValue('hedgeTypeId') || this.dealModel.defaultHedgeTypeId
                  return hedgeTypeId
                },
              },
              commission: {
                type: 'number',
                defaultValue: () => {
                  const commission =
                    this.getLastItemValue('numberContract') *
                    this.dealModel.futureContractCommission
                  return commission || 0
                },
              },
              isExercised: {type: 'boolean', defaultValue: false},
              otherBarrier2: {type: 'number'},
              optionTypeId: {
                type: 'number',
                defaultValue: () => {
                  var legCode = this.getLastItemValue('legCode')
                  return ['', 'FUT'].includes(legCode) ? 0 : 1
                },
              },
              optionTypeName: {
                type: 'string',
                defaultValue: () => {
                  var legCode = this.getLastItemValue('legCode')
                  return ['', 'FUT'].includes(legCode) ? 'N/A' : 'Euro'
                },
              },
              settlementMethodId: {type: 'number', defaultValue: 2},
              settlementMethodName: {type: 'string', defaultValue: 'Physical'},
            },
          },
        },
        change: e => {
          if (e.action != 'itemchange') return
          const item = e.items[0]
          switch (e.field) {
            case 'numberContract':
            case 'contractSize':
              item.set('quantity', item.contractSize * item.numberContract || 0)
              item.set(
                'commission',
                item.numberContract * this.dealModel.futureContractCommission || 0,
              )
              break
            case 'quantity':
            case 'price': {
              const {quantity, price} = item
              item.set('ccyAmount', quantity * price)
              this.recalculateGainLoss(this.dealModel.referenceRate, item)
              break
            }
            case 'contractMonth': {
              if (item.contractMonth != null) {
                const date = new Date(item.contractMonth)
                const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0)
                item.set('lastDeliveryDate', endOfMonth)
              }
              break
            }
            case 'lastDeliveryDate': {
              const endOfMonth = new Date(
                item.lastDeliveryDate.getFullYear(),
                item.lastDeliveryDate.getMonth() + 1,
                0,
              )
              item.set('yearMonth', endOfMonth)
              break
            }
            case 'isBuying':
              this.recalculateGainLoss(this.dealModel.referenceRate, item)
              break
            case 'legCode': {
              const optionTypeId = item.legCode == 'FUT' ? 0 : 1
              const optionTypeName = item.legCode == 'FUT' ? 'N/A' : 'Euro'

              item.set('optionTypeId', optionTypeId)
              item.set('optionTypeName', optionTypeName)
              break
            }
          }
        },
      })
    },
  },
  components: {
    PageToolbar,
    RangeDeals,
    TicketForm,
  },
}
</script>
